import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  // Checkbox,
  // FormControlLabel,
} from "@mui/material";
import { IoClose } from "react-icons/io5";
import AddPredictors from "components/predictors/AddPredictors";
import useSearch from "hooks/algolia/useSearch";
import { getPredictors } from "api-algolia/predictors.api";

// const defaultCategories = [
//   { label: "Քաղաքական", value: "politic" },
//   { label: "Սոցիալական", value: "social" },
//   { label: "Տնտեսական", value: "economic" },
//   { label: "Մարգարեական", value: "prophetic" },
//   { label: "Ֆինանսական", value: "finance" },
//   { label: "Սպորտային", value: "sport" },
// ];

const PredictorsDialog = ({
  items,
  selected,
  onChange,
  open,
  onClose,
  isLoading,
  getNextPage,
  page,
  setPage,
  hasMoreItems,
  label,
  // category,
  // setCategory = () => {},
  // categories = defaultCategories,
}) => {
  const { setSearchText, searchText, searchResult } = useSearch({
    getData: getPredictors,
  });

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <DialogTitle>
        <div className="flex justify-between">
          {label}
          <Button onClick={onClose}>
            <IoClose color="gray" size={30} />
          </Button>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          placeholder="Որոնում"
          type="text"
          autoComplete="off"
          sx={{
            backgroundColor: "#F5F7FF",
            borderRadius: "14px",
            margin: "0 0 24px",
            "& fieldset": { border: "none" },
          }}
          className="w-full md:w-fit"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        {/* {categories.map((cat) => {
          return (
            <FormControlLabel
              control={
                <Checkbox
                  checked={category === cat.value}
                  color="primary"
                  onChange={(e) =>
                    setCategory(
                      category === e.target.value ? "" : e.target.value
                    )
                  }
                  value={cat.value}
                />
              }
              label={cat.label}
              key={cat.value}
            />
          );
        })} */}
        <AddPredictors
          searchResult={searchResult}
          selected={selected}
          onChange={onChange}
          items={items}
          isLoadingNextPage={isLoading}
          hasMoreItems={hasMoreItems}
          getNextPage={getNextPage}
          page={page}
          setPage={setPage}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PredictorsDialog;
